import React from 'react';
import { IconIconAttribute } from '@wisereducacao-npm/design-system-core-web/dist/components/icon/types';

import { TextParagraphContainer } from '../../styles';
import { IconContainer } from './styles';
import { formatTextBasedOnProductName } from '../../utils';

import { DsIcon, DsTypography } from 'componentsV2/DS';

export interface HeaderProps {
  mainProductName?: string;
  upsellProductName?: string;
  icon: IconIconAttribute;
  title: string;
  subtitle: string;
}

export const Header = ({
  icon,
  title,
  subtitle,
  mainProductName = '',
  upsellProductName = '',
}: HeaderProps) => {
  return (
    <>
      <IconContainer>
        <DsIcon icon={icon} size="sm" color="secondary-pure" />
      </IconContainer>

      <DsTypography
        component="heading"
        size="medium"
        color="secondary-pure"
        dangerouslySetInnerHTML={{
          __html: title,
        }}
      />

      <TextParagraphContainer>
        <DsTypography
          component="paragraph"
          size="large"
          dangerouslySetInnerHTML={{
            __html: formatTextBasedOnProductName(
              subtitle,
              mainProductName,
              upsellProductName
            ),
          }}
        />
      </TextParagraphContainer>
    </>
  );
};
